import { connect } from 'react-redux';
import { dispatchify, recall } from 'common/utils/utils';
import { shouldStopGetReposRecall } from 'common/services/http-polling-stopper';
import {
  DateSelectionChanged,
  getTeams,
  updateTeam,
  updateTeamContributors,
  createRepositories,
  toggleSnackBar,
  getRepositories
} from 'state/callers';
import {
  getLatestIterationSelector,
  iterationsPickerSelector
} from 'state/selectors/iterations-picker';
import { selectTeamId, setIsProcessingRepos, toggleModal } from 'state/actions';
import {
  hasIterationsSelector,
  hasNoDataSelector,
  selectedTeamSelector
} from 'state/selectors/ui-state';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';
import { contributorsSelector } from 'state/selectors/contributors';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import TopBar from './TopBar';

const mapStateToProps = state => {
  const { uiState, currentTeams, organization, sensorAuthorizations } = state;

  return {
    currentTeams,
    uiState,
    iterationsPickerData: iterationsPickerSelector(state),
    selectedTeam: selectedTeamSelector(state),
    isTeamLicense: isTeamLicenseSelector(state),
    organization,
    contributors: contributorsSelector(state),
    license: licenseSelector(state),
    hasNoData: hasNoDataSelector(state),
    latestIteration: getLatestIterationSelector(state),
    gitIntegrations: gitIntegrationsSelector(state),
    sensorAuthorizations,
    hasIterations: hasIterationsSelector(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...dispatchify(dispatch, {
      DateSelectionChanged,
      selectTeamId,
      toggleModal,
      getTeams,
      updateTeam,
      updateTeamContributors,
      createRepositories,
      setIsProcessingRepos,
      toggleSnackBar,
      getRepositories
    }),
    ...recall(
      {
        ...dispatchify(dispatch, {
          // eslint-disable-next-line jsdoc/require-jsdoc
          getRepositories: () => getRepositories()
        })
      },
      shouldStopGetReposRecall,
      60
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);
